module.exports = new __parcel__URL__("filter_oudormir.4ecb28e7.png").toString();